import React, { useState, useEffect, useRef } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getOverviewBusinessGrapth } from '../../../redux/profile/action';
import ExportButtons from '../ExportButtons';
import { prepareChartData } from '../../../utils/graphUtils';

const BasicChartLineGraphHistory = ({ start_date, end_date, type }) => {
  const dispatch = useDispatch();
  const graphdetails = useSelector(
    ({ profile: { dashboardoverviewbusinessgraph } }) => dashboardoverviewbusinessgraph
  );
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (start_date && end_date && type) {
      dispatch(getOverviewBusinessGrapth(start_date, end_date, type));
    }
  }, [start_date, end_date, type, dispatch]);

  useEffect(() => {
    if (Array.isArray(graphdetails?.task) && graphdetails.task.length > 0) {
      const formattedData = prepareChartData(graphdetails.task, 'count');
      setChartData(formattedData);
    } else {
      setChartData([]);
    }
  }, [graphdetails]);

  return (
    <div ref={chartRef}>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            interval={0}
            textAnchor="end"
            height={60}
            tick={{ fontSize: 12 }}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#8884d8"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BasicChartLineGraphHistory;
